<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import productCard from './product-card.vue';
import * as subcategoriesApi from '../api/subcategories';

interface Props {
  category: Category
  products?: Product[] | null
}
const props = defineProps<Props>();

const subcategories = ref<Subcategory[]>([]);
const selectedSubcategoryId = ref();

function clearSubcategory() {
  selectedSubcategoryId.value = null;
}

function handleBack() {
  window.history.back();
}

function getSubcategories() {
  subcategoriesApi.index(props.category.id)
    .then((response) => {
      subcategories.value = response.data.subcategories;
    });
}

const filteredProducts = computed(() => {
  if (selectedSubcategoryId.value) {
    return props.products?.filter(product => product.subcategory.id === selectedSubcategoryId.value);
  }

  return props.products;
});

onMounted(() => {
  getSubcategories();
});
</script>
<template>
  <the-layout hide-navbar>
    <div class="bg-white md:mx-auto md:my-6 md:h-[calc(100vh-72px-24px-24px)] md:max-w-md md:overflow-y-scroll md:rounded">
      <the-titlebar
        :title="category.name"
        @back="handleBack"
      />
      <div>
        <div
          v-if="filteredProducts"
          class="relative w-full"
        >
          <div
            class="flex w-full items-center justify-between space-x-2 border-y border-z-gray-100 bg-z-gray-50 px-6 py-2"
          >
            <p class="text-sm text-z-gray-800">
              Subcategoría:
            </p>
            <div class="flex items-center space-x-2">
              <button
                v-if="selectedSubcategoryId"
                class="shrink-0 rounded-full bg-z-gray-600"
                @click="clearSubcategory"
              >
                <img
                  src="@/assets/icons/close.svg"
                  class="h-4 w-4 invert"
                >
              </button>
              <select
                v-model="selectedSubcategoryId"
                class="w-full rounded-sm border border-z-gray-50 bg-white px-2 py-1 text-sm"
              >
                <option
                  v-for="subcategory in subcategories"
                  :key="subcategory.id"
                  :value="subcategory.id"
                >
                  {{ subcategory.name }}
                </option>
              </select>
            </div>
          </div>
          <p class="mt-4 px-6 text-center text-sm text-z-gray-800">
            Encontramos
            {{ filteredProducts.length }}
            producto{{ filteredProducts.length === 1 ? '' : 's' }}
            en esta
            {{ selectedSubcategoryId ? 'sub' : '' }}categoría:
          </p>
          <div
            class="mt-4 grid grid-cols-2 gap-4 px-6 pb-6"
          >
            <product-card
              v-for="product in filteredProducts"
              :key="product.id"
              :product="product"
            />
          </div>
        </div>
        <div
          v-else
          class="flex flex-col items-center px-6"
        >
          <img
            src="@/assets/icons/task-search.svg"
            class="h-16 w-16"
          >
          <p class="mt-6">
            No hay productos en esta categoría
          </p>
          <p class="mt-6 text-center">
            ¡Aprovecha esta oportunidad y
          </p>
          <a
            href="/como_subir"
            class="text-center font-medium text-z-turquoise-700 underline"
          >publica ahora!</a>
        </div>
      </div>
    </div>
  </the-layout>
</template>
